export default "__VITE_ASSET__BAMdYh$X__"